"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CommentListSectionHeader = _interopRequireDefault(require("./CommentListSectionHeader"));

var _CommentListSection = _interopRequireDefault(require("./CommentListSection.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CommentListSection = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _classNames;

  var children = _ref.children,
      compactCommentingMode = _ref.compactCommentingMode,
      disableActiveStyling = _ref.disableActiveStyling,
      hideHeader = _ref.hideHeader,
      id = _ref.id,
      isActive = _ref.isActive,
      isEmpty = _ref.isEmpty,
      nodeId = _ref.nodeId,
      onActiveSectionChange = _ref.onActiveSectionChange,
      onActiveSectionHeaderClick = _ref.onActiveSectionHeaderClick,
      onInactiveSectionClick = _ref.onInactiveSectionClick,
      scrollTop = _ref.scrollTop,
      subtitle = _ref.subtitle,
      title = _ref.title;
  var headerRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      sticky = _useState2[0],
      setSticky = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    if (isActive) {
      onActiveSectionChange(nodeId);
    }

    setSticky(false);
  }, [isActive, nodeId, onActiveSectionChange]);
  (0, _react.useLayoutEffect)(function () {
    if (!headerRef || !headerRef.current) {
      setSticky(false);
      return;
    } // toggle the bottom border of the section header when user scrolls


    if (headerRef.current.offsetTop !== 0 && headerRef.current.offsetTop <= scrollTop) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  }, [compactCommentingMode, scrollTop]);
  var handleClick = (0, _react.useCallback)(function () {
    if (isActive) {
      return;
    }

    onInactiveSectionClick(nodeId);
  }, [isActive, nodeId, onInactiveSectionClick]);
  var handleHeaderClick = (0, _react.useCallback)(function () {
    if (!isActive) {
      return;
    }

    onActiveSectionHeaderClick();
  }, [isActive, onActiveSectionHeaderClick]);
  var handleKeyDown = (0, _react.useCallback)(function (event) {
    if (event.key === 'Enter') {
      handleClick();
    }
  }, [handleClick]);
  var sectionClassName = (0, _classnames.default)(_CommentListSection.default.component, (_classNames = {}, _defineProperty(_classNames, _CommentListSection.default.active, isActive && !disableActiveStyling), _defineProperty(_classNames, _CommentListSection.default.compactCommentingMode, compactCommentingMode), _defineProperty(_classNames, _CommentListSection.default.inactive, !isActive), _classNames));

  if (isEmpty && !isActive || compactCommentingMode && !isActive) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("section", {
    ref: ref,
    "aria-disabled": !isActive,
    className: sectionClassName,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    "data-testid": id
  }, !compactCommentingMode && !hideHeader && /*#__PURE__*/_react.default.createElement(_CommentListSectionHeader.default, {
    ref: headerRef,
    id: id,
    title: title,
    subtitle: subtitle,
    sticky: sticky,
    onClick: handleHeaderClick
  }), children);
});
CommentListSection.defaultProps = {
  onActiveSectionChange: function onActiveSectionChange() {},
  onActiveSectionHeaderClick: function onActiveSectionHeaderClick() {},
  onInactiveSectionClick: function onInactiveSectionClick() {}
};
CommentListSection.propTypes = {
  children: _propTypes.default.node.isRequired,
  compactCommentingMode: _propTypes.default.bool,
  disableActiveStyling: _propTypes.default.bool,
  hideHeader: _propTypes.default.bool,
  id: _propTypes.default.string,
  isActive: _propTypes.default.bool,
  isEmpty: _propTypes.default.bool,
  nodeId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onActiveSectionChange: _propTypes.default.func,
  onActiveSectionHeaderClick: _propTypes.default.func,
  onInactiveSectionClick: _propTypes.default.func,
  scrollTop: _propTypes.default.number,
  subtitle: _propTypes.default.string,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired
};
var _default = CommentListSection;
exports.default = _default;